import { useCallback, useEffect, useRef, useState } from 'react';

export const usePromoDropdownControls = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const filterButtonRef = useRef<HTMLButtonElement>(null);
  const filterContainerRef = useRef<HTMLDivElement>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  useEffect(() => {
    const handleDocumentPointerDown = (event: PointerEvent) => {
      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      if (!containerRef.current?.contains(target)) {
        setIsDropdownOpen(false);
        setIsFilterOpen(false);

        return;
      }

      if (isFilterOpen && !filterContainerRef.current?.contains(target) && !filterButtonRef.current?.contains(target)) {
        setIsFilterOpen(false);
      }
    };
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || !isFilterOpen) {
        return;
      }

      event.preventDefault();
      setIsFilterOpen(false);
      filterButtonRef.current?.focus();
    };

    document.addEventListener('pointerdown', handleDocumentPointerDown);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('pointerdown', handleDocumentPointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isFilterOpen]);

  const onDropdownToggle = useCallback(() => {
    setIsDropdownOpen((currentValue) => {
      const isOpen = !currentValue;

      if (!isOpen) {
        setIsFilterOpen(false);
      }

      return isOpen;
    });
  }, []);

  const onFilterToggle = useCallback(() => {
    setIsFilterOpen((isOpen) => !isOpen);
  }, []);

  return {
    containerRef,
    filterButtonRef,
    filterContainerRef,
    isDropdownOpen,
    isFilterOpen,
    triggerRef,
    onDropdownToggle,
    onFilterToggle,
  };
};
